var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 5C20.625 3.61937 19.5056 2.5 18.125 2.5C16.7444 2.5 15.625 3.61937 15.625 5C15.625 5.78375 15.625 11.0881 15.625 11.875C15.625 13.2556 16.7444 14.375 18.125 14.375C19.5056 14.375 20.625 13.2556 20.625 11.875C20.625 11.0881 20.625 5.78375 20.625 5Z",
    fill: "#33D375"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.875 11.875C26.875 13.2556 25.7556 14.375 24.375 14.375C23.6281 14.375 21.875 14.375 21.875 14.375C21.875 14.375 21.875 12.5087 21.875 11.875C21.875 10.4944 22.9944 9.375 24.375 9.375C25.7556 9.375 26.875 10.4944 26.875 11.875Z",
    fill: "#33D375"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5 8.75C3.61937 8.75 2.5 9.86937 2.5 11.25C2.5 12.6306 3.61937 13.75 5 13.75C5.78375 13.75 11.0881 13.75 11.875 13.75C13.2556 13.75 14.375 12.6306 14.375 11.25C14.375 9.86937 13.2556 8.75 11.875 8.75C11.0881 8.75 5.78375 8.75 5 8.75Z",
    fill: "#40C4FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.875 2.5C13.2556 2.5 14.375 3.61937 14.375 5C14.375 5.74688 14.375 7.5 14.375 7.5C14.375 7.5 12.5087 7.5 11.875 7.5C10.4944 7.5 9.375 6.38063 9.375 5C9.375 3.61937 10.4944 2.5 11.875 2.5Z",
    fill: "#40C4FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 24.3788C8.75 25.7575 9.86937 26.875 11.25 26.875C12.6306 26.875 13.75 25.7575 13.75 24.3788C13.75 23.5963 13.75 18.2994 13.75 17.5138C13.75 16.135 12.6306 15.0175 11.25 15.0175C9.86937 15.0175 8.75 16.135 8.75 17.5138C8.75 18.2994 8.75 23.5963 8.75 24.3788Z",
    fill: "#E91E63"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.5138C2.5 16.135 3.61937 15.0175 5 15.0175C5.74688 15.0175 7.5 15.0175 7.5 15.0175C7.5 15.0175 7.5 16.8806 7.5 17.5138C7.5 18.8925 6.38063 20.01 5 20.01C3.61937 20.01 2.5 18.8925 2.5 17.5138Z",
    fill: "#E91E63"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.375 20.625C25.7556 20.625 26.875 19.5056 26.875 18.125C26.875 16.7444 25.7556 15.625 24.375 15.625C23.5913 15.625 18.2869 15.625 17.5 15.625C16.1194 15.625 15 16.7444 15 18.125C15 19.5056 16.1194 20.625 17.5 20.625C18.2863 20.625 23.5913 20.625 24.375 20.625Z",
    fill: "#FFC107"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 26.875C16.1194 26.875 15 25.7556 15 24.375C15 23.6281 15 21.875 15 21.875C15 21.875 16.8662 21.875 17.5 21.875C18.8806 21.875 20 22.9944 20 24.375C20 25.7556 18.8806 26.875 17.5 26.875Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.97e2f6e85d1469163ba089c95fff33c2.svg";
export { ForwardRef as ReactComponent };